<template>
    <div id="supplierManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <!-- <el-form-item style="margin-bottom:15px"class="hewidth">
                <el-select v-model="searchForm.allottedTime" placeholder="请选择账期" clearable>
                    <el-option v-for="(item,index) in pickingAllowList" 
                        :label="item.paraName" 
                        :value="item.paraValue" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.supplierCode" placeholder="请输入供应商编号"></el-input>
            </el-form-item> -->
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-select filterable clearable v-model="searchForm.supplierName" placeholder="请选择供应商">
                    <el-option v-for="(item,index) in supplierDataList" 
                        :label="item.supplierName" 
                        :value="item.supplierName" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
           <!--  <el-form-item style="margin-bottom:15px" class="hewidth">
               <el-select filterable clearable v-model="searchForm.contactsName" placeholder="请选择联系人">
                   <el-option v-for="(item,index) in supplierDataList" 
                       :label="item.contactsName" 
                       :value="item.contactsName" 
                       :key="index">
                   </el-option>
               </el-select>
           </el-form-item>
           <el-form-item style="margin-bottom:15px"class="hewidth">
               <el-select filterable clearable v-model="searchForm.contactsPhone" placeholder="请选择联系方式">
                   <el-option v-for="(item,index) in supplierDataList" 
                       :label="item.contactsPhone" 
                       :value="item.contactsPhone" 
                       :key="index">
                   </el-option>
               </el-select>
           </el-form-item> -->
             <!-- <div class="clearfix"> -->
            <el-form-item style="width: 20%; margin-bottom:15px" >
                <el-input clearable v-model.trim="searchForm.site" placeholder="请输入供应商地址"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%; margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <!-- <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button> -->
                <el-button size="medium" type="success" @click="createMater" v-if="supplierAuth.createMater">新建供应商</el-button>
                    <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <!-- <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 5px;" @click="refresh()"></i> -->
            </el-form-item>
       <!--  </div> -->
            <!-- <el-form-item class="fr">
                <el-col style="text-align:right">
                    
                </el-col>
            </el-form-item> -->
        </el-form>
        <el-col>
            <el-card class="box-card" style="width: 100%;">
                <el-table
                    :data="supplierData"
                    border
                    id="tableId"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        prop="supplierCode"
                        width="180"
                        label="供应商编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="supplierName"
                        width="180"
                        label="供应商">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="contactsName"
                        label="联系人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="contactsPhone"
                        width="110"
                        label="联系方式">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="site"
                        width="220"
                        label="供应商地址">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="allottedTime"
                        label="账期">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                        <template  slot-scope="scope">
                            <span v-if="scope.row.status == '1'">启用</span>
                            <span v-if="scope.row.status == '-1'">禁用</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUser"
                        width="120"
                        label="创建人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        width="110"
                        :formatter="dateFormat"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        v-if="supplierAuth.handleExit"
                        label="操作"
                        width="60">
                        <template slot-scope="scope">
                            <el-button @click="handleExit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next,jumper"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
                <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogCreate" :close-on-click-modal="false" width="700px" @close="emptyDialog('supplierForm')">
                    <el-form ref="supplierForm" :model="supplierForm" label-width="120px" :label-position="labelPosition" :rules="supplierFormRules">
                        <el-form-item label="供应商名称：" prop="supplierName">
                            <el-input v-model.trim="supplierForm.supplierName"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人："  prop="contactsName">
                            <el-input v-model.trim="supplierForm.contactsName"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式：" prop="contactsPhone">
                            <el-input v-model.trim="supplierForm.contactsPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="地址：" prop="site">
                            <el-input v-model.trim="supplierForm.site"></el-input>
                        </el-form-item>
                        <el-form-item label="账期：" prop="allottedTime">
                            <el-select v-model.trim="supplierForm.allottedTime" placeholder="请选择账期" style="width: 80%;">
                                <el-option v-for="(item,index) in paymentDayList" :label="item.paraName" :value="item.paraName" :key="index"></el-option>
                            </el-select>
                            <span>(单位：天)</span>
                        </el-form-item>
                        <el-form-item label="启用状态:">
                            <el-switch 
                                v-model="formIsValid" 
                                :active-value="1" 
                                :inactive-value="-1" 
                                active-text="启用"
                                inactive-text="禁用"
                                @change='changeSwitch()'>
                            </el-switch>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer" >
                        <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="newSupplierSubmit('supplierForm')">立即创建</el-button>
                        <el-button v-else type="success" @click="saveEventFormSubmitBtn('supplierForm')">保存</el-button> 
                        <el-button @click="emptyDialog('supplierForm')">取 消</el-button> 
                    </span>
                </el-dialog>
            </el-card>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {
        getsupplierList,supplierAdd,supplierEdit,getpaymentDayList
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest'
    export default {
        name: 'supplierManage',
        components: {},
        data () {
            const validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback()
                } else {
                    if (!(/^1[345789]\d{9}$/.test(value))) {
                        callback(new Error('请输入正确的11位手机号'))
                    }
                    callback()
                }
            }
            return {
                activeIndex:'',
                formIsValid:1,
                paymentDayList:[],
                //分页
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                choose:'',
                dataList:[],
                dislogCreate:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改供应商",
                    create: "新增供应商"
                },
                labelPosition:'left',
                supplierForm:{
                    supplierCode:'',
                    supplierName: '',
                    contactsName: '',
                    contactsPhone:'',
                    site:'',
                    allottedTime: '',
                    status: 1,
                },
                supplierFormRules:{//validateRoleName
                    supplierName: [{ required: true, message: "请输入供应商名称", trigger: "submit" }],
                    contactsName: [{ required: true, message: "请输入联系人", trigger: "submit" }],
                    site: [{ required: true, message: "请输入供应商地址", trigger: "submit" }],
                    contactsPhone: [{ validator: validatePhone, trigger: 'submit' }]
                },
                searchForm:{
                    supplierCode: '',
                    supplierName: '',
                    contactsPhone: '',
                    contactsName: '',
                    allottedTime:'',
                    site: '',
                },
                pickingAllowList:[
                    {
                        paraName:'7天',
                        paraValue:'7'
                    },
                    {
                        paraName:'15天',
                        paraValue:'15'
                    },
                    {
                        paraName:'30天',
                        paraValue:'30'
                    },
                    {
                        paraName:'60天',
                        paraValue:'60'
                    }
                ],
                supplierData: [
                    {
                        supplierName: '',
                        contactsName: '',
                        contactsPhone:'',
                        site:'',
                        allottedTime: '',
                        status:'',
                        createUser:'',
                        createTime:''
                    }
                ],
                supplierDataList:[],
                supplierAuth:{
                    createMater:false,
                    showFn:false,
                    onSubmit:false,
                    handleExit:false,
                }
            }
        },
        created(){
            this.$destroy();
            this.getsupplierLists();
            this.getsupplierDataLists();
            this.getpaymentDayLists();
        },
        mounted () {
            
            this.supplierAuth.createMater= getPermission('/api/supplier/supplierAdd');
            this.supplierAuth.showFn= getPermission('/api/supplier/getpaymentDayList');
            this.supplierAuth.onSubmit= getPermission('/api/supplier/getsupplierList');
            this.supplierAuth.handleExit= getPermission('/api/supplier/supplierEdit');
        },
        methods: {
            clearFrom(){
                this.searchForm = {
                    supplierCode: '',
                    supplierName: '',
                    contactsPhone: '',
                    contactsName: '',
                    allottedTime:'',
                    site: '',
                };
            },
            //获取供应商列表
            getsupplierDataLists() {
                let para={
                    supplierCode:"",
                    supplierName:"",
                    contactsName:"",
                    contactsPhone:"",
                    site:"",
                    allottedTime:"",
                    status:1,
                    startRow: 1,
                    pageSize: 10000
                }
                getsupplierList(para).then(res => {
                    if (res.data.status==100) {
                        this.supplierDataList = res.data.results.list
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            changeSwitch() {
                // console.log(this.formIsValid)
                this.supplierForm.status = this.formIsValid
            },
            //获取账期列表
            getpaymentDayLists() {
                getpaymentDayList().then(res => {
                    if (res.data.status==100) {
                        this.paymentDayList = res.data.results
                        this.dataList = res.data.results
                        // console.log(this.dataList)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取供应商列表
            getsupplierLists() {
                let para={
                    supplierCode:this.searchForm.supplierCode,
                    supplierName:this.searchForm.supplierName,
                    contactsName:this.searchForm.contactsName,
                    contactsPhone:this.searchForm.contactsPhone,
                    site:this.searchForm.site,
                    allottedTime:this.searchForm.allottedTime,
                    status:1,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                getsupplierList(para).then(res => {
                    if (res.data.status==100) {
                        this.supplierData = res.data.results.list
                        this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogCreate = false
            },
            //新建
            createMater() {
                this.dislogCreate = true
                this.dialogMenuStatus = "create";
            },
            //确认新建
            newSupplierSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            supplierName:this.supplierForm.supplierName,
                            contactsName:this.supplierForm.contactsName,
                            contactsPhone:this.supplierForm.contactsPhone,
                            site:this.supplierForm.site,
                            allottedTime:this.supplierForm.allottedTime,
                            status:this.supplierForm.status,
                        }
                        supplierAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新列表*/
                                this.getsupplierLists();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            handle:function(index,key){
                var _this = this;
                var count = 0; 
                var item=this.category[index].items;
                item.filter(function(v,i){
                    if(i==key){
                        v.active=true;      
                        _this.condition.filter(function(v2,i){
                            if(v.name==v2.name){
                                _this.condition.splice(i,1);
                                count--;
                            }
                        });         
                        Vue.set(_this.condition,count++,v);
                    }
                });
            },
            remove:function(index){
                var item=this.category[index].items;
                item.filter(function (v1,key) {
                    v1.active=false;
                    this.condition.filter(function(v2,i){
                        if(v1.name==v2.name){
                            this.condition.splice(i,1);
                            count--;
                        }
                    });
                });
            },
            allIn:function(index){
                var item=this.category[index].items;
                item.filter(function (v,key) {
                    v.active=true;
                    this.condition.filter(function(v2,i){
                        if(v.name==v2.name){
                            this.condition.splice(i,1);
                            count--;
                        }
                    });         
                    Vue.set(this.condition,count++,v);
                });     
            },
            refresh() {
                this.getsupplierLists()
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            supplierCode:this.searchForm.supplierCode,
                            supplierName:this.searchForm.supplierName,
                            contactsName:this.searchForm.contactsName,
                            contactsPhone:this.searchForm.contactsPhone,
                            site:this.searchForm.site,
                            allottedTime:this.searchForm.allottedTime,
                            status:1,
                            startRow: this.pages.page,
                            pageSize: this.pages.pageSize
                        }
                        getsupplierList(para).then(res => {
                            if (res.data.status==100) {
                                this.supplierData = res.data.results.list
                                // console.log(res.data.results)
                                this.pages.page = res.data.results.startRow
                                this.pages.total = res.data.results.total
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
              });
            },
            //修改供应商
            handleExit(index, row){
                this.dislogCreate = true
                this.dialogMenuStatus = "update";
                this.supplierForm = Object.assign({}, row);
                // this.supplierForm = row
            },
            //保存修改
            saveEventFormSubmitBtn(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            id:this.supplierForm.id,
                            supplierName:this.supplierForm.supplierName,
                            contactsName:this.supplierForm.contactsName,
                            contactsPhone:this.supplierForm.contactsPhone,
                            site:this.supplierForm.site,
                            allottedTime:this.supplierForm.allottedTime,
                            status:this.supplierForm.status,
                        }
                        supplierEdit(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogCreate = false;
                                this.$refs[formname].resetFields();
                                /*刷新列表*/
                                this.getsupplierLists();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pages.pageSize = val
                // console.log(this.configureInfo.pageSize)
                this.getsupplierLists()
            },
            handleCurrentChange(Page) {
                // console.log(`当前页: ${Page}`);
                this.pages.page = Page
                // console.log(this.configureInfo.currentPage)
                this.getsupplierLists()
            },
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #supplierManage{
        font-size: 14px; 
        .el-dialog__footer{
            text-align: center;
        }
        .headerT{
            font-size: 16px;
            margin:0 0 15px 0;
        }
    }
     .hewidth {
        width: 18% !important;
      }
</style>



// WEBPACK FOOTER //
// supplierManage.vue?55f4303c